import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import baseUrl from "../../API/BaseUrl";

const initialState = {
  SubCategory: [],
  subCatDetails: [],
  AllSubCategory: [],
  DeleteSubCategory: [],
  isLoading: true,
  isSuccess: true,
  errorMessage: "",
};

// create new Sub Category
export const createSubCategory = createAsyncThunk(
  "subCategory/createNew",
  async (data) => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
        },
      }
      const res = await baseUrl.post("/api/v1/subcategories", data, config);
      return res;
    } catch (error) {
      return error;
    }
  }
);

// get All Sub Category
export const getAllSubCategory = createAsyncThunk(
  "subCat/getAll", async () => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
        },
      }
      const res = await baseUrl.get("/api/v1/subcategories",config);
      return res;
    } catch (error) {
      return error;
    }
  }
);

// get all subcategories based on category
export const getSubCatONMainCat = createAsyncThunk(
  "subOnCat/getAll",
  async (catId) => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
        },
      }
      const res = await baseUrl.get(`/api/v1/categories/${catId}/subcategories`,config);
      return res;
    } catch (error) {
      return error;
    }
  }
);

// get subcategory data
export const getsubCatDetails = createAsyncThunk("subCatDetails/getOne", async (id) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      },
    }
    const res = await baseUrl.get(`/api/v1/subcategories/${id}`,config);
    return res.data.data
  } catch (error) {
    return error
  }
})

// delete subcategory 
export const deleteSubCategory = createAsyncThunk("deletesubCat/deleteOne", async (id) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      },
    }
    const res = await baseUrl.delete(`/api/v1/subcategories/${id}`,config);
    return res.data.data
  } catch (error) {
    return error
  }
})


const SubCategorySlice = createSlice({
  name: "subCategory",
  initialState,
  reducers: {},
  extraReducers: {
    [createSubCategory.pending]: (state, action) => {
      state.isLoading = true;
    },
    [createSubCategory.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.SubCategory = action.payload;
    },
    [createSubCategory.rejected]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.errorMessage = action.payload;
    },
    [getSubCatONMainCat.pending]: (state, action) => {
      state.isLoading = true;
    },
    [getSubCatONMainCat.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.SubCategory = action.payload;
    },
    [getSubCatONMainCat.rejected]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.errorMessage = action.payload;
    },
    [getsubCatDetails.pending]: (state, action) => {
      state.isLoading = true;
    },
    [getsubCatDetails.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.subCatDetails = action.payload;
    },
    [getsubCatDetails.rejected]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.errorMessage = action.payload;
    },
    [getAllSubCategory.pending]: (state, action) => {
      state.isLoading = true;
    },
    [getAllSubCategory.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.AllSubCategory = action.payload;
    },
    [getAllSubCategory.rejected]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.errorMessage = action.payload;
    },
    [deleteSubCategory.pending]: (state, action) => {
      state.isLoading = true;
    },
    [deleteSubCategory.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.DeleteSubCategory = action.payload;
    },
    [deleteSubCategory.rejected]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.errorMessage = action.payload;
    }
  },
});

export default SubCategorySlice.reducer;
